import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b3f1bbc6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b3f1bbc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1bbc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3f1bbc6')) {
      api.createRecord('b3f1bbc6', component.options)
    } else {
      api.reload('b3f1bbc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b3f1bbc6&scoped=true&", function () {
      api.rerender('b3f1bbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadVedio/index.vue"
export default component.exports